import { ShieldCheck } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

export const expertVerifiedSince = (e) => (e && e.status === "approved" && !e.is_example ? e.approved_at || null : null);

const monthYear = (iso, lang) => new Date(iso).toLocaleDateString(lang === "en" ? "en-GB" : "fr-FR", { month: "long", year: "numeric" });

export const VerifiedBadge = ({ since, compact = false, testid }) => {
  const { t, lang } = useLang();
  const v = t.verified;
  if (!since) return null;
  const sinceText = v.since(monthYear(since, lang));
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`verified-badge${compact ? " compact" : ""}`} tabIndex={0} role="img" aria-label={`${v.label} — ${sinceText}. ${v.tip}`} data-testid={testid}>
            <ShieldCheck aria-hidden="true" />
            <span className="vb-label">{v.label}</span>
            {!compact && <span className="vb-since">{sinceText}</span>}
          </span>
        </TooltipTrigger>
        <TooltipContent className="verified-tip" data-testid={testid ? `${testid}-tooltip` : undefined}>
          <b>{v.label}</b> · {sinceText}<br />{v.tip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
